import ModalContainer from './container';
import Modal from './Modal';

export { Modal };
export default ModalContainer;
